module.exports = __webpack_public_path__ + "static/media/labora_logo.d1bf5490.png";